import React from 'react';
import { BookmarkPage } from '@edwin-group/cj-graphql';
import Divider from '@/components/Divider';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { getTranslatedValue } from '../../utils/getTranslatedValue';

interface BookmarkListCardProps<T> {
  title: string;
  data: T[];
  showDivider?: boolean;
  page?: BookmarkPage;
  viewAll?: boolean;
  viewAllText?: string;
  handleLoadMore?: () => void;
  renderCard: (item: T, index: number) => React.ReactNode;
}

export function BookmarkListCard<T>({ title, data, showDivider = true, page, renderCard }: BookmarkListCardProps<T>) {
  if (!data?.length) {
    return null;
  }

  const displayTitle = page ? getTranslatedValue({ title, page }) : title;

  return (
    <AnimatedFadeInComponent key={title}>
      <div key={title} className="mb-sh-30">
        <div className="flex items-center justify-between">
          <h3 className="mb-sh-30 font-cadiz text-sh-md font-bold">{displayTitle}</h3>
        </div>
        <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2 md:gap-4">
          {data.map((item, index) => renderCard(item, index))}
        </div>
      </div>
      {showDivider ? <Divider /> : null}
    </AnimatedFadeInComponent>
  );
}
